var f = Object.defineProperty;
var p = (u, e, t) => e in u ? f(u, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : u[e] = t;
var c = (u, e, t) => p(u, typeof e != "symbol" ? e + "" : e, t);
import k from "eventemitter2";
import { isRequestInFlight as g, NetworkStatus as m } from "../../networkStatus.mjs";
import _ from "./store.mjs";
const S = {
  archived: "exclude"
}, v = 2e3;
class U {
  constructor(e, t, s) {
    c(this, "userFeedId");
    c(this, "channel");
    c(this, "broadcaster");
    c(this, "defaultOptions");
    c(this, "broadcastChannel");
    c(this, "disconnectTimer", null);
    c(this, "hasSubscribedToRealTimeUpdates", !1);
    c(this, "visibilityChangeHandler", () => {
    });
    c(this, "visibilityChangeListenerConnected", !1);
    // The raw store instance, used for binding in React and other environments
    c(this, "store");
    this.knock = e, this.feedId = t, this.feedId = t, this.userFeedId = this.buildUserFeedId(), this.store = _(), this.broadcaster = new k({ wildcard: !0, delimiter: "." }), this.defaultOptions = { ...S, ...s }, this.knock.log(`[Feed] Initialized a feed on channel ${t}`), this.initializeRealtimeConnection(), this.setupBroadcastChannel();
  }
  /**
   * Used to reinitialize a current feed instance, which is useful when reauthenticating users
   */
  reinitialize() {
    this.userFeedId = this.buildUserFeedId(), this.initializeRealtimeConnection(), this.setupBroadcastChannel();
  }
  /**
   * Cleans up a feed instance by destroying the store and disconnecting
   * an open socket connection.
   */
  teardown() {
    this.knock.log("[Feed] Tearing down feed instance"), this.channel && (this.channel.leave(), this.channel.off("new-message")), this.teardownAutoSocketManager(), this.disconnectTimer && (clearTimeout(this.disconnectTimer), this.disconnectTimer = null), this.broadcastChannel && this.broadcastChannel.close();
  }
  /** Tears down an instance and removes it entirely from the feed manager */
  dispose() {
    this.knock.log("[Feed] Disposing of feed instance"), this.teardown(), this.broadcaster.removeAllListeners(), this.knock.feeds.removeInstance(this);
  }
  /*
    Initializes a real-time connection to Knock, connecting the websocket for the
    current ApiClient instance if the socket is not already connected.
  */
  listenForUpdates() {
    if (this.knock.log("[Feed] Connecting to real-time service"), this.hasSubscribedToRealTimeUpdates = !0, !this.knock.isAuthenticated()) {
      this.knock.log(
        "[Feed] User is not authenticated, skipping listening for updates"
      );
      return;
    }
    const e = this.knock.client().socket;
    e && !e.isConnected() && e.connect(), this.channel && ["closed", "errored"].includes(this.channel.state) && this.channel.join();
  }
  /* Binds a handler to be invoked when event occurs */
  on(e, t) {
    this.broadcaster.on(e, t);
  }
  off(e, t) {
    this.broadcaster.off(e, t);
  }
  getState() {
    return this.store.getState();
  }
  async markAsSeen(e) {
    const t = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      e,
      "seen",
      { seen_at: t },
      "unseen_count"
    ), this.makeStatusUpdate(e, "seen");
  }
  async markAllAsSeen() {
    const { metadata: e, items: t, ...s } = this.store.getState();
    if (this.defaultOptions.status === "unseen")
      s.resetStore({
        ...e,
        total_count: 0,
        unseen_count: 0
      });
    else {
      s.setMetadata({ ...e, unseen_count: 0 });
      const i = { seen_at: (/* @__PURE__ */ new Date()).toISOString() }, o = t.map((r) => r.id);
      s.setItemAttrs(o, i);
    }
    const n = await this.makeBulkStatusUpdate("seen");
    return this.emitEvent("all_seen", t), n;
  }
  async markAsUnseen(e) {
    return this.optimisticallyPerformStatusUpdate(
      e,
      "unseen",
      { seen_at: null },
      "unseen_count"
    ), this.makeStatusUpdate(e, "unseen");
  }
  async markAsRead(e) {
    const t = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      e,
      "read",
      { read_at: t },
      "unread_count"
    ), this.makeStatusUpdate(e, "read");
  }
  async markAllAsRead() {
    const { metadata: e, items: t, ...s } = this.store.getState();
    if (this.defaultOptions.status === "unread")
      s.resetStore({
        ...e,
        total_count: 0,
        unread_count: 0
      });
    else {
      s.setMetadata({ ...e, unread_count: 0 });
      const i = { read_at: (/* @__PURE__ */ new Date()).toISOString() }, o = t.map((r) => r.id);
      s.setItemAttrs(o, i);
    }
    const n = await this.makeBulkStatusUpdate("read");
    return this.emitEvent("all_read", t), n;
  }
  async markAsUnread(e) {
    return this.optimisticallyPerformStatusUpdate(
      e,
      "unread",
      { read_at: null },
      "unread_count"
    ), this.makeStatusUpdate(e, "unread");
  }
  async markAsInteracted(e, t) {
    const s = (/* @__PURE__ */ new Date()).toISOString();
    return this.optimisticallyPerformStatusUpdate(
      e,
      "interacted",
      {
        read_at: s,
        interacted_at: s
      },
      "unread_count"
    ), this.makeStatusUpdate(e, "interacted", t);
  }
  /*
    Marking one or more items as archived should:
  
    - Decrement the badge count for any unread / unseen items
    - Remove the item from the feed list when the `archived` flag is "exclude" (default)
  
    TODO: how do we handle rollbacks?
    */
  async markAsArchived(e) {
    const t = this.store.getState(), s = this.defaultOptions.archived === "exclude", a = Array.isArray(e) ? e : [e], n = a.map((i) => i.id);
    if (s) {
      const i = a.filter((l) => !l.seen_at).length, o = a.filter((l) => !l.read_at).length, r = {
        ...t.metadata,
        // Ensure that the counts don't ever go below 0 on archiving where the client state
        // gets out of sync with the server state
        total_count: Math.max(0, t.metadata.total_count - a.length),
        unseen_count: Math.max(0, t.metadata.unseen_count - i),
        unread_count: Math.max(0, t.metadata.unread_count - o)
      }, d = t.items.filter(
        (l) => !n.includes(l.id)
      );
      t.setResult({
        entries: d,
        meta: r,
        page_info: t.pageInfo
      });
    } else
      t.setItemAttrs(n, { archived_at: (/* @__PURE__ */ new Date()).toISOString() });
    return this.makeStatusUpdate(e, "archived");
  }
  async markAllAsArchived() {
    const { items: e, ...t } = this.store.getState();
    if (this.defaultOptions.archived === "exclude")
      t.resetStore();
    else {
      const n = e.map((i) => i.id);
      t.setItemAttrs(n, { archived_at: (/* @__PURE__ */ new Date()).toISOString() });
    }
    const a = await this.makeBulkStatusUpdate("archive");
    return this.emitEvent("all_archived", e), a;
  }
  async markAllReadAsArchived() {
    const { items: e, ...t } = this.store.getState(), a = e.filter((o) => o.read_at === null).map((o) => o.id);
    if (t.setItemAttrs(a, {
      archived_at: (/* @__PURE__ */ new Date()).toISOString()
    }), this.defaultOptions.archived === "exclude") {
      const o = e.filter((d) => !a.includes(d.id)), r = {
        ...t.metadata,
        total_count: o.length,
        unread_count: 0
      };
      t.setResult({
        entries: o,
        meta: r,
        page_info: t.pageInfo
      });
    }
    return await this.makeBulkStatusUpdate("archive");
  }
  async markAsUnarchived(e) {
    return this.optimisticallyPerformStatusUpdate(e, "unarchived", {
      archived_at: null
    }), this.makeStatusUpdate(e, "unarchived");
  }
  /* Fetches the feed content, appending it to the store */
  async fetch(e = {}) {
    const { networkStatus: t, ...s } = this.store.getState();
    if (!this.knock.isAuthenticated()) {
      this.knock.log("[Feed] User is not authenticated, skipping fetch");
      return;
    }
    if (g(t)) {
      this.knock.log("[Feed] Request is in flight, skipping fetch");
      return;
    }
    s.setNetworkStatus(e.__loadingType ?? m.loading);
    const a = {
      ...this.defaultOptions,
      ...e,
      // Unset options that should not be sent to the API
      __loadingType: void 0,
      __fetchSource: void 0,
      __experimentalCrossBrowserUpdates: void 0,
      auto_manage_socket_connection: void 0,
      auto_manage_socket_connection_delay: void 0
    }, n = await this.knock.client().makeRequest({
      method: "GET",
      url: `/v1/users/${this.knock.userId}/feeds/${this.feedId}`,
      params: a
    });
    if (n.statusCode === "error" || !n.body)
      return s.setNetworkStatus(m.error), {
        status: n.statusCode,
        data: n.error || n.body
      };
    const i = {
      entries: n.body.entries,
      meta: n.body.meta,
      page_info: n.body.page_info
    };
    if (e.before) {
      const d = { shouldSetPage: !1, shouldAppend: !0 };
      s.setResult(i, d);
    } else if (e.after) {
      const d = { shouldSetPage: !0, shouldAppend: !0 };
      s.setResult(i, d);
    } else
      s.setResult(i);
    this.broadcast("messages.new", i);
    const o = e.__fetchSource === "socket" ? "items.received.realtime" : "items.received.page", r = {
      items: i.entries,
      metadata: i.meta,
      event: o
    };
    return this.broadcast(r.event, r), { data: i, status: n.statusCode };
  }
  async fetchNextPage() {
    const { pageInfo: e } = this.store.getState();
    e.after && this.fetch({
      after: e.after,
      __loadingType: m.fetchMore
    });
  }
  broadcast(e, t) {
    this.broadcaster.emit(e, t);
  }
  // Invoked when a new real-time message comes in from the socket
  async onNewMessageReceived({
    metadata: e
  }) {
    this.knock.log("[Feed] Received new real-time message");
    const { items: t, ...s } = this.store.getState(), a = t[0];
    s.setMetadata(e), this.fetch({ before: a == null ? void 0 : a.__cursor, __fetchSource: "socket" });
  }
  buildUserFeedId() {
    return `${this.feedId}:${this.knock.userId}`;
  }
  optimisticallyPerformStatusUpdate(e, t, s, a) {
    const n = this.store.getState(), i = Array.isArray(e) ? e : [e], o = i.map((r) => r.id);
    if (a) {
      const { metadata: r } = n, d = i.filter((h) => {
        switch (t) {
          case "seen":
            return h.seen_at === null;
          case "unseen":
            return h.seen_at !== null;
          case "read":
          case "interacted":
            return h.read_at === null;
          case "unread":
            return h.read_at !== null;
          default:
            return !0;
        }
      }), l = t.startsWith("un") ? d.length : -d.length;
      n.setMetadata({
        ...r,
        [a]: Math.max(0, r[a] + l)
      });
    }
    n.setItemAttrs(o, s);
  }
  async makeStatusUpdate(e, t, s) {
    const a = Array.isArray(e) ? e : [e], n = a.map((o) => o.id), i = await this.knock.messages.batchUpdateStatuses(
      n,
      t,
      { metadata: s }
    );
    return this.emitEvent(t, a), i;
  }
  async makeBulkStatusUpdate(e) {
    const t = {
      user_ids: [this.knock.userId],
      engagement_status: this.defaultOptions.status !== "all" ? this.defaultOptions.status : void 0,
      archived: this.defaultOptions.archived,
      has_tenant: this.defaultOptions.has_tenant,
      tenants: this.defaultOptions.tenant ? [this.defaultOptions.tenant] : void 0
    };
    return await this.knock.messages.bulkUpdateAllStatusesInChannel({
      channelId: this.feedId,
      status: e,
      options: t
    });
  }
  setupBroadcastChannel() {
    this.broadcastChannel = typeof self < "u" && "BroadcastChannel" in self ? new BroadcastChannel(`knock:feed:${this.userFeedId}`) : null, this.broadcastChannel && this.defaultOptions.__experimentalCrossBrowserUpdates === !0 && (this.broadcastChannel.onmessage = (e) => {
      switch (e.data.type) {
        case "items:archived":
        case "items:unarchived":
        case "items:seen":
        case "items:unseen":
        case "items:read":
        case "items:unread":
        case "items:all_read":
        case "items:all_seen":
        case "items:all_archived":
          return this.fetch();
        default:
          return null;
      }
    });
  }
  broadcastOverChannel(e, t) {
    if (this.broadcastChannel)
      try {
        const s = JSON.parse(JSON.stringify(t));
        this.broadcastChannel.postMessage({
          type: e,
          payload: s
        });
      } catch (s) {
        console.warn(`Could not broadcast ${e}, got error: ${s}`);
      }
  }
  initializeRealtimeConnection() {
    const { socket: e } = this.knock.client();
    e && (this.channel = e.channel(
      `feeds:${this.userFeedId}`,
      this.defaultOptions
    ), this.channel.on("new-message", (t) => this.onNewMessageReceived(t)), this.defaultOptions.auto_manage_socket_connection && this.setupAutoSocketManager(), this.hasSubscribedToRealTimeUpdates && this.knock.isAuthenticated() && (e.isConnected() || e.connect(), this.channel.join()));
  }
  /**
   * Listen for changes to document visibility and automatically disconnect
   * or reconnect the socket after a delay
   */
  setupAutoSocketManager() {
    typeof document > "u" || this.visibilityChangeListenerConnected || (this.visibilityChangeHandler = this.handleVisibilityChange.bind(this), this.visibilityChangeListenerConnected = !0, document.addEventListener("visibilitychange", this.visibilityChangeHandler));
  }
  teardownAutoSocketManager() {
    typeof document > "u" || (document.removeEventListener(
      "visibilitychange",
      this.visibilityChangeHandler
    ), this.visibilityChangeListenerConnected = !1);
  }
  emitEvent(e, t) {
    this.broadcaster.emit(`items.${e}`, { items: t }), this.broadcaster.emit(`items:${e}`, { items: t }), this.broadcastOverChannel(`items:${e}`, { items: t });
  }
  handleVisibilityChange() {
    var s;
    const e = this.defaultOptions.auto_manage_socket_connection_delay ?? v, t = this.knock.client();
    document.visibilityState === "hidden" ? this.disconnectTimer = setTimeout(() => {
      var a;
      (a = t.socket) == null || a.disconnect(), this.disconnectTimer = null;
    }, e) : document.visibilityState === "visible" && (this.disconnectTimer && (clearTimeout(this.disconnectTimer), this.disconnectTimer = null), (s = t.socket) != null && s.isConnected() || this.initializeRealtimeConnection());
  }
}
export {
  U as default
};
//# sourceMappingURL=feed.mjs.map
